module.exports = __webpack_public_path__ + "img/96.b7dff0c9.png";